import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { SiteLayout } from './components/layout/SiteLayout';
import { ScrollManager } from './components/navigation/ScrollManager';

import HomePage from './pages/HomePage';
import OffersPage from './pages/OffersPage';
import OfferReviewPage from './pages/OfferReviewPage';
import ComparisonPage from './pages/ComparisonPage';
import AboutPage from './pages/AboutPage';
import FaqPage from './pages/FaqPage';
import PrivacyPolicyPage from './pages/policies/PrivacyPolicyPage';
import CookiesPolicyPage from './pages/policies/CookiesPolicyPage';
import TermsPage from './pages/policies/TermsPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <SiteLayout>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/offres" element={<OffersPage />} />
        <Route path="/offres/:slug" element={<OfferReviewPage />} />
        <Route path="/comparatif-offres" element={<ComparisonPage />} />
        <Route path="/a-propos" element={<AboutPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/politique-confidentialite" element={<PrivacyPolicyPage />} />
        <Route path="/politique-cookies" element={<CookiesPolicyPage />} />
        <Route path="/conditions" element={<TermsPage />} />
        <Route path="/comparaison" element={<Navigate to="/comparatif-offres" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </SiteLayout>
  );
}

export default App;
